import { render } from "./PhotoViewer.vue?vue&type=template&id=32aef28e&scoped=true"
import script from "./PhotoViewer.vue?vue&type=script&lang=js"
export * from "./PhotoViewer.vue?vue&type=script&lang=js"

import "./photo-viewer.scss?vue&type=style&index=0&id=32aef28e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aef28e"]])

export default __exports__